import React from 'react';
import { connect } from 'react-redux';
import { scoreUntilScenarioSelector } from '../services/store';

import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';

const mapStateToProps = (state) => ({
  score: scoreUntilScenarioSelector(6)(state),
});

const Chapter7 = ({
  id,
  trackEvent,
  score,
}) => (
  <Chapter
    id={id}
    theme="green"
    title="08.00 uur, vrijdag"
    onEnter={() => trackEvent(id)}
  >
    <Text>Je hebt je verslapen. Je eet snel wat en rent het huis uit. Op weg naar de trein.</Text>
    {score <= 560 && (
      <Scenario
        id="7"
        title="Welke neem je?"
        description="Je komt te laat op je werk! Aangekomen op het station zijn er twee opties: de snelle trein of de stoptrein."
        scoreFirst={-50}
        scoreSecond={-50}
        buttonTextFirst="De sneltrein"
        buttonTextSecond="De stoptrein"
        resultTextFirst="De sneltrein kun je alleen nemen bij 600 punten of meer. Je kan dus niet mee en moet de stoptrein nemen. Je komt te laat op je je werk."
        resultTextSecond="De stoptrein is langzaam en vol. Je komt te laat op je werk en krijgt een notitie."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    {score > 560 && score < 600 && (
      <Scenario
        id="7"
        title="Welke neem je?"
        description="Je komt te laat bij je sollicitatiegesprek. Aangekomen op het station zijn er twee opties: de snelle trein, of de stoptrein."
        scoreFirst={0}
        scoreSecond={0}
        buttonTextFirst="De sneltrein"
        buttonTextSecond="De stoptrein"
        resultTextFirst="De sneltrein kun je alleen nemen bij 600 punten of meer. Je kan dus niet mee en moet de stoptrein nemen. Je komt te laat. Naar die baan kun je fluiten."
        resultTextSecond="De stoptrein is langzaam en vol. Je komt te laat bij je gesprek. Naar die baan kun je fluiten."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    {score >= 600 && (
      <Scenario
        id="7"
        title="Wat doe je?"
        description="Je komt te laat bij je sollicitatiegesprek. Aangekomen op het station zijn er twee opties: de snelle trein of de stoptrein."
        scoreFirst={20}
        scoreSecond={0}
        buttonTextFirst="De sneltrein"
        buttonTextSecond="De stoptrein"
        resultTextFirst="Je krijgt een melding als je incheckt. Geniet van jouw speciale sneltreinrit. Je komt op tijd én krijgt de baan. Jouw score is afhankelijk van jouw kredietwaardigheid en dus ook van hoeveel geld je hebt. Een nieuwe baan betekent een beter inkomen."
        resultTextSecond="De stoptrein is langzaam en vol. Je komt te laat bij je gesprek. Naar die baan kun je fluiten."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    <Box>
      <h3>Hoe gaat het systeem eruit zien?</h3>
      <Text>Hoe het sociale systeem van de overheid er precies uit gaat zien, is nog niet duidelijk. Sommige regeringsleiders willen alle gegevens van burgers gebruiken voor de score, dus ook de gegevens die Alibaba over je heeft. Maar die gegevens deelt het bedrijf nog niet.</Text>
      <Text>De overheid weet ook zonder Alibaba veel van je. Ook zij hebben in de grote steden camera’s hangen met gezichtsherkenning. Maar al die data combineren voor je score, dat ziet niet iedereen zitten.</Text>
      <Text>Tegenstanders vinden het systeem niet haalbaar en denken dat burgers het niet gaan pikken als dit wordt ingevoerd. Hoe het eruit komt te zien, is dus afwachten.</Text>
    </Box>
  </Chapter>
);

export default connect(mapStateToProps)(Chapter7);



// WEBPACK FOOTER //
// ./src/chapters/Chapter7.js